<template>
  <div class="query-table-container noselect" v-loading="loading">
    <search-pager
      v-if="formTools && formTools.length && !option.dialog"
      ref="searchPager"
      :option="option"
      :tools="formTools"
      @switch-unit="handleSwitchUnit">
    </search-pager>
    <div v-if="configError" class="error" @click="getGenericSearchFields">
      获取配置失败，<span class="theme">请点击</span> 重新获取
    </div>
    <slot name="header"></slot>
    <div
      style="display:flex;"
      :class="option.pageFooter ? 'kye-dialog-body' : ''">
      <slot name="prepend"></slot>
      <div :style="bodyStyle">
        <slot name="form-header"></slot>
        <div :class="queryFormWrap">
          <query-form
            ref="queryForm"
            v-if="formFields && formFields.length > 0"
            v-model="formModel"
            :fields="formFields"
            :tools="tools"
            :option="option"
            :generic="null"
            :generic-model="genericModel"
            :template-list="templateList"
            @created="triggerHttp"
            @submit="formSubmit"
            @reset="formReset">
            <template slot="before">
              <slot name="query-form-before"></slot>
            </template>
            <template slot="after">
              <slot name="query-form-after"></slot>
            </template>
          </query-form>
        </div>
        <tool-list
          ref="tools"
          v-if="tools && tools.length && !option.inlineTools"
          :wrap-style="toolsWrapStyle"
          :tools="tools">
        </tool-list>
        <KyeDataStatisticWrap
          ref="dataStatisticWrap"
          v-if="dataStatisticOption"
          v-on="$listeners"
          :dataStatisticOption="dataStatisticOption"
        >
        </KyeDataStatisticWrap>
        <slot name="desc"></slot>
        <el-tabs
          v-if="tables && tables.length > 1"
          class="query-table-container-tabs"
          v-model="active"
          @tab-click="tabClick">
          <el-tab-pane
            v-for="(item,i) in tables"
            :key="i"
            :disabled="tabDisabled(item.url)"
            :label="getTabLabel(item.option, i)">
            <slot :name="'table-list-before'+i"></slot>
            <kye-table2-wrap
              v-if="item.option.customTable === 'table2'"
              :style="tableListStyle"
              ref="tableList"
              :callProps="item.callProps"
              :data="getTableData(i)"
              :tableConfig="item"
              :max-height="option.maxHeight"
              :search-code="item.searchCode"
              :max-decrypt-config="maxDecryptConfig[item.url.method]"
              :page="{currentPage: remotePage[i], pageSize: pageSize(i), total: total(i)}"
              :pageable="item.option.page"
              :uploadOptions="item.uploadOptions"
              :row-key="item.option.rowKey"
              :slotComponent="$scopedSlots"
              :tableName="option.tableName"
              :dialog="option.dialog"
              :offset-left="option.offsetLeft"
              :defaultSort="item.option.defaultSort"
              :options="item.option"
              @switch-menu="switchMenu"
              @cell-click="item.option.anyCellClick"
              @select="emitSelectEvent"
              @select-all="emitSelectAllEvent($event, item)"
              @header-move="headerMove"
              @header-enter="emitHeaderEnter"
              @cell-mouse-enter="emitCellMouseEnter"
              @cell-mouse-leave="emitCellMouseLeave"
              @table-leave="tableLeave"
              @table-scroll="tableScroll"
              @collapsed="e => emitCollapsed(i, e)"
              @sort-change="e => sortChange(i, e)"
              @call-success="emitCallSuccess"
              @decrypt-success="emitDecryptSuccess">
              <template slot="footer">
                <slot name="footer"></slot>
              </template>
            </kye-table2-wrap>
            <table-list
              v-else
              ref="tableList"
              :callProps="item.callProps"
              :max-decrypt-config="maxDecryptConfig[item.url.method]"
              :style="tableListStyle"
              :scrollY="scrollY"
              :page="{currentPage: remotePage[i], pageSize: pageSize(i), total: total(i)}"
              :pageable="item.option.page"
              :data="getTableData(i)"
              :options="item.option"
              :dialog="option.dialog"
              :fixed-header="option.fixedHeader"
              :max-height="option.maxHeight"
              :min-height="option.minHeight"
              :offset-left="option.offsetLeft"
              :search-code="item.searchCode"
              :column="item.columns"
              :operation="item.operation"
              :buttonOptions="item.buttonOptions"
              :imageOptions="item.imageOptions"
              :checkedOptions="item.checkedOptions"
              :uploadOptions="item.uploadOptions"
              :sortOptions="item.sortOptions"
              :drawColumnOptions="item.drawColumnOptions"
              :headRenderOptions="item.headRenderOptions"
              :layerColumnOptions="item.layerColumnOptions"
              :headerTipOptions="item.headerTipOptions"
              @column-width-change="columnWidthChange"
              @cell-click="item.option.cellClick"
              @any-cell-click="item.option.anyCellClick"
              @switch-menu="switchMenu"
              @header-move="headerMove"
              @cell-move="cellMove"
              @any-cell-move="anyCellMove"
              @table-leave="tableLeave"
              @table-scroll="tableScroll"
              @sort-change="e => sortChange(i, e)"
              @collapsed="e => emitCollapsed(i, e)"
              @call-success="emitCallSuccess"
              @decrypt-success="emitDecryptSuccess">
              <slot :name="'tooltip'+i"></slot>
            </table-list>
            <kye-pagination
              v-if="item.option.page"
              :class="option.dialog ? '' : 'fixedPagination'"
              :style="fixedPaginationStyle"
              background
              :current-page="page(i)"
              :page-size="pageSize(i)"
              :page-sizes="pageSizes"
              :total="total(i)"
              :layout="total(i) > 0 ? $pagination.layout2 : $pagination.layout"
              :disabledMaxPage="disabledMaxPage(i)"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
              <el-button class="jumper-button" type="primary" plain>确定</el-button>
            </kye-pagination>
          </el-tab-pane>
        </el-tabs>
        <template v-else-if="tables && tables.length === 1">
          <kye-table2-wrap
            v-if="tables[0].option.customTable === 'table2'"
            :style="tableListStyle"
            ref="tableList"
            :callProps="tables[0].callProps"
            :data="getTableData(0)"
            :tableConfig="tables[0]"
            :max-decrypt-config="maxDecryptConfig[tables[0].url.method]"
            :pageable="tables[0].option.page"
            :uploadOptions="tables[0].uploadOptions"
            :search-code="tables[0].searchCode"
            :page="{currentPage: remotePage[0], pageSize: pageSize(0), total: total(0)}"
            :max-height="option.maxHeight"
            :row-key="tables[0].option.rowKey"
            :slotComponent="$scopedSlots"
            :tableName="option.tableName"
            :dialog="option.dialog"
            :offset-left="option.offsetLeft"
            :defaultSort="tables[0].option.defaultSort"
            :options="tables[0].option"
            @switch-menu="switchMenu"
            @column-width-change="columnWidthChange"
            @cell-click="tables[0].option.anyCellClick"
            @header-move="headerMove"
            @select="emitSelectEvent"
            @select-all="emitSelectAllEvent"
            @header-enter="emitHeaderEnter"
            @cell-mouse-enter="emitCellMouseEnter"
            @cell-mouse-leave="emitCellMouseLeave"
            @table-leave="tableLeave"
            @table-scroll="tableScroll"
            @sort-change="e => sortChange(0, e)"
            @collapsed="e => emitCollapsed(0, e)"
            @call-success="emitCallSuccess"
            @decrypt-success="emitDecryptSuccess">
            <template slot="footer">
              <slot name="footer"></slot>
            </template>
          </kye-table2-wrap>
          <table-list
            v-else
            ref="tableList"
            :callProps="tables[0].callProps"
            :max-decrypt-config="maxDecryptConfig[tables[0].url.method]"
            :style="tableListStyle"
            :scrollY="scrollY"
            :page="{currentPage: remotePage[0], pageSize: pageSize(0), total: total(0)}"
            :pageable="tables[0].option.page"
            :data="getTableData(0)"
            :options="tables[0].option"
            :dialog="option.dialog"
            :fixed-header="option.fixedHeader"
            :max-height="option.maxHeight"
            :min-height="option.minHeight"
            :offset-left="option.offsetLeft"
            :search-code="tables[0].searchCode"
            :column="tables[0].columns"
            :operation="tables[0].operation"
            :buttonOptions="tables[0].buttonOptions"
            :imageOptions="tables[0].imageOptions"
            :checkedOptions="tables[0].checkedOptions"
            :uploadOptions="tables[0].uploadOptions"
            :sortOptions="tables[0].sortOptions"
            :drawColumnOptions="tables[0].drawColumnOptions"
            :headRenderOptions="tables[0].headRenderOptions"
            :layerColumnOptions="tables[0].layerColumnOptions"
            :headerTipOptions="tables[0].headerTipOptions"
            @column-width-change="columnWidthChange"
            @cell-click="tables[0].option.cellClick"
            @any-cell-click="tables[0].option.anyCellClick"
            @switch-menu="switchMenu"
            @header-move="headerMove"
            @cell-move="cellMove"
            @any-cell-move="anyCellMove"
            @table-leave="tableLeave"
            @table-scroll="tableScroll"
            @sort-change="e => sortChange(0, e)"
            @collapsed="e => emitCollapsed(0, e)"
            @call-success="emitCallSuccess"
            @decrypt-success="emitDecryptSuccess">
            <slot name="tooltip"></slot>
          </table-list>
          <kye-pagination
            v-if="!option.pageFooter && tables[0].option.page"
            :class="option.dialog ? '' : 'fixedPagination'"
            :style="fixedPaginationStyle"
            background
            :current-page="page(0)"
            :page-size="pageSize(0)"
            :page-sizes="pageSizes"
            :pager-count="option.dialog ? 5 : 7"
            :total="total(0)"
            :layout="total(0) > 0 ? $pagination.layout2 : $pagination.layout"
            :disabledMaxPage="disabledMaxPage(0)"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
            <el-button class="jumper-button" type="primary" plain>确定</el-button>
          </kye-pagination>
        </template>
      </div>
      <slot name="append"></slot>
    </div>
    <kye-pagination
      v-if="option.pageFooter && tables && tables.length === 1 && tables[0].option.page"
      class="el-dialog__footer"
      background
      :current-page="page(0)"
      :page-size="pageSize(0)"
      :page-sizes="pageSizes"
      :pager-count="5"
      :total="total(0)"
      :layout="total(0) > 0 ? $pagination.layout2 : $pagination.layout"
      :disabledMaxPage="disabledMaxPage(0)"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
      <el-button class="jumper-button" type="primary" plain>确定</el-button>
    </kye-pagination>
    <custom-filter
      v-if="generic && generic.searchCode && !generic.group"
      ref="genericDialog"
      :module="generic"
      @open="openGenericDialog"
      @close="showGenericDialog(false)"
      @submit="genericSubmit"
      @loaded="onGenericLoaded"
      @reset="onGenericReset"
      @onTemplateListChange="onTemplateListChange">
    </custom-filter>
    <custom-filter-group
      v-if="generic && generic.searchCode && generic.group"
      ref="genericDialog"
      :module="generic"
      @open="openGenericDialog"
      @close="showGenericDialog(false)"
      @submit="genericSubmit"
      @loaded="onGenericLoaded"
      @reset="onGenericReset"
      @onTemplateListChange="onTemplateListChange">
    </custom-filter-group>
    <drag-dialog
      v-if="option.draggable && (option.searchCode || tables[0].searchCode)"
      ref="dragDialog"
      :option="option"
      :tables="tables"
      :generic="generic"
      :form-fields="copyFormFields"
      :depts="depts"
      @dept-change="mergeDept"
      @save="columnsChange"
      @close="showDragDialog(false)">
    </drag-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import './module/bus'
  import { intersection, cloneDeep } from 'lodash'
  import { random, localPageSize, exportQueryLog, getMenuIdByRoute } from '../../utils'
  import {
    HTTP_ACTION,
    filterFieldsByAuthCode,
    perfectVos,
    perfectRows,
    mapFormModelParams,
    mapGenericSearchParams,
    mapSectionValueList
  } from './utils'
  import DecryptPlugin from '../../utils/decrypt-plugin'
  import { queryCurrentMenuIdDecryptConfig, checkBatchDecryptConf } from '../../utils/decrypt-max-plugin'
  // 通用查询用户使用情况埋点分析上报
  import { genericSearchFieldsUpload, updateReportTimeByCodes } from 'public/utils/fields-log'
  import createStoreModule from '../../store/modules/queryTable/factory'
  import CustomFilter from './custom-filter.vue'
  import CustomFilterGroup from './custom-filter-group.vue'
  import DragDialog from './drag-dialog.vue'
  import TableList from './table-list.vue'
  import KyeTable2Wrap from './table2/kye-table2-wrap'
  // 数据统计包装组件
  import KyeDataStatisticWrap from './data-statistic/data-statistic-wrap.js'
  // 个性设置数据处理（排序）
  import { mergeFormFields, updateFormFieldShowStatus } from './module/form-field'

  import { TABLE_EVENTS } from './config/events'


  const EMPTY_ARR = [] // 防止 canvas watch 反复执行，影响性能

  export default {
    name: 'query-table',
    provide () {
      return {
        queryForm: this
      }
    },
    components: { CustomFilter, CustomFilterGroup, DragDialog, TableList, KyeTable2Wrap, KyeDataStatisticWrap },
    props: {
      searchCodes: { // 可选，支持已知通用查询code查询
        type: Array,
        default: () => ([])
      },
      generic: {
        type: Object,
        default: () => ({})
      },
      option: {
        type: Object,
        default: () => ({})
      },
      formTools: {
        type: Array,
        default: () => ([])
      },
      formModel: Object,
      formFields: {
        type: Array,
        default: () => ([])
      },
      tools: {
        type: Array,
        default: () => ([])
      },
      tables: Array,
      isLoading: Boolean, // 是否局部loading
      dataStatisticOption: [Object, Array]
    },
    data () {
      const sty = (this.$slots.prepend || this.$slots.append)
        ? { 'overflow-x': 'hidden' }
        : { 'max-width': '100%' }
      const params = this.tables[0].url.data
      return {
        canLoad: false,
        loading: false,
        configError: false,
        offsetLeft: 176 + (this.option.offsetLeft || 0),
        forceCache: true,
        scrollY: false,
        active: '0',
        formIndex: -1,
        remotePage: [1, 1],
        pageMap: { page: 1, pageSize: localPageSize(this, params && params.pageSize) },
        copyFormFields: { columns: this.formFields, $columns: [...this.formFields] },
        bodyStyle: Object.assign({ flex: 1 }, sty),
        genericModel: null,
        templateList: [],
        depts: [],
        toolsWrapStyle: { marginBottom: '2px' },
        maxDecryptConfig: {},
        collectTimerArr: [],
      }
    },
    created() {
      this.initOption()
      this.initTables()
      this.registerStoreModule()
      this.getGenericSearchFields()
      if (this.canRefresh()) {
        this.refreshUnwatch = this.$watch('refreshMap', this.onRefreshMainQueryTable)
      }
    },
    activated () {
      // 2021-04-09 处理极端情况下未注册时, 重复注册
      const module = this.$store.state.queryTable[this.option.module]
      if (!module) {
        // 2021-12-15 多个keep-alive导致实际缓存未被清掉，重复注册会导致数据出现联动关系
        if (this.option.module) {
          try {
            if (this.$store._modules.root._children.queryTable._children[this.option.module]) {
              this.$store.unregisterModule(['queryTable', this.option.module])
            }
          } catch (e) {
            console.log(`[query-table]: ${e}`)
          }
        }
        this.registerStoreModule()
      }
      this.onRefreshMainQueryTable()
      if (this.hasResize) {
        this.handleResize()
      }
      this.createPoll()
    },
    deactivated () {
      this.destoryPoll()
    },
    mounted () {
      this.setCurrentMenuIdDecryptConfig()
      this.$bus.$on('GLOBAL_RESIZE', this.handleResize)
    },
    beforeDestroy () {
      this.$bus.$off('GLOBAL_RESIZE', this.handleResize)
      this.refreshUnwatch && this.refreshUnwatch()
      // 组件销毁前移除接口定时器
      this.destoryPoll()
    },
    watch: {
      '$store.state.globalMoneyFormatType': function (val) {
        this.loadLocalData({ index: +this.active, cb: rows => rows })
      }
    },
    computed: {
      queryTableAction () {
        return this.$store.state.queryTable.$action
      },
      queryModule () {
        if (this.option.module) {
          const module = this.$store.state.queryTable[this.option.module]
          return module ? module.query : []
        }
        return this.tables.map(v => v.url)
      },
      refreshMap () {
        return this.$store.state.queryTable.$refreshMap
      },
      localRefreshMap () {
        return this.$store.state.queryTable.$localRefreshMap
      },
      fixedPaginationStyle () {
        if (this.option.dialog) {
          return { marginTop: '10px' }
        }
        let obj = { left: `${this.offsetLeft}px` }
        if (this.option.fixedHeader) {
          obj.width = '1280px'
        } else {
          obj.right = '16px'
        }
        return obj
      },
      tableListStyle () {
        // 滚动条2+10 + 分页28+8
        return this.option.dialog ? { marginTop: '4px' } : { marginTop: '4px', marginBottom: '48px' }
      },
      queryFormWrap () {
        // 默认超过一行不限制高度
        const hasMaxRows = this.option.maxRows && parseInt(this.option.maxRows) > 1
        if (this.option.overflow || hasMaxRows) {
          return 'query-form-wrap_overflow'
        }
        if (!this.option.searchCode && this.formFields.length === 0) {
          return 'query-form-wrap_none'
        }
        return 'query-form-wrap'
      },
      pageSizes () {
        return this.tables[0].option.pageSizes || this.$pagination.pageSizes
      },
      permissionMenus () {
        return this.$store.getters.permission.menus
      },
    },
    methods: {
      // 清除列表数据
      clearData (index = 0) {
        const res = { rowTotal: 0, rows: [] }
        if (this.option.module) {
          this.setQuery({ index, res })
        } else {
          Object.assign(this.tables[index].url.res, res)
        }
      },
      // 刷新列表数据，设置页码为1
      loadData (params, index, method, axios, action) {
        if (typeof index !== 'number') {
          index = +this.active
        }
        let data = { ...params, page: this.pageMap.page }
        if (this.option.module) {
          this.setQuery({ index, data })
        } else {
          Object.assign(this.tables[index].url.data, data)
        }
        if (this.canLoad) {
          this.forceCache = true
          this.tables[index].method = method
          this.tables[index].axios = axios
          return this.getList(index, method, action || HTTP_ACTION.REFRESH)
        }
        return Promise.resolve(false)
      },
      // 根据缓存的参数，刷新当前页码的列表数据
      loadCurrentData (index = 0, method) {
        if (this.canLoad) {
          this.forceCache = true
          this.getList(index, method, HTTP_ACTION.PAGER)
        }
      },
      // 重新渲染本地数据
      async loadLocalData (opt) {
        if (!opt.cb) {
          console.log('[query-table]: cb 未配置')
          return
        }
        try {
          let index = opt.index || 0
          let obj = this.queryModule[index]
          if (obj && obj.res && obj.res.rows && obj.res.rows.length) {
            let rows = await opt.cb(obj.res.rows)
            if (Array.isArray(rows) && rows.length) {
              if (opt.module && opt.module === this.option.module) {
                this.$store.state.queryTable[opt.module].query[index].res.rows = rows
              } else {
                this.tables[index].url.res.rows = rows
              }
              if (this.tables.length === 1) {
                this.$refs.tableList.$refs.table.loadLocalData()
              } else {
                this.$refs.tableList[index].$refs.table.loadLocalData()
              }
            } else {
              this.isRefresh = true
              this.tables.forEach((v, i) => this.loadCurrentData(i, v.method))
            }
          }
        } catch (e) {
          console.error('[query-table]:', e)
        }
      },
      loadHeader (params, index = 0) {
        return this.getHeader(this.tables[index], params, index)
      },
      getFormModel () {
        return this.$refs.queryForm && this.$refs.queryForm.getModel()
      },
      // 重置自定义查询表单
      resetForm () {
        this.$refs.queryForm && this.$refs.queryForm.onReset()
      },
      // 动态设置自定义表单的内容
      setFormModel (data) {
        this.$refs.queryForm && this.$refs.queryForm.setModel(data)
      },
      // 手动触发自定义表单查询事件
      submit () {
        this.$refs.queryForm && this.$refs.queryForm.onSubmit()
      },
      // 手动修改querfrom 的 menu 下拉值（key: 字段名, index: 下拉索引）
      changeMenuItemIndex (key, index) {
        this.$refs.queryForm && this.$refs.queryForm.changeMenuItemIndex(key, index)
      },
      getParams (index = 0) {
        let generic = { generic: { vos: [] }, elasticsearchFlag: 'Y', ...this.pageMap }
        let obj = this.queryModule[index]
        if (obj && obj.data) {
          if (!obj.data.generic) {
            obj.data.generic = generic
          }
          // 删除接口缓存标志
          obj = cloneDeep(obj.data)
          if (obj.generic && obj.generic.vos) {
            perfectVos(obj.generic.vos)
          }
          delete obj.ERPSearchCacheFlag
          delete obj.forceCache
          return obj
        }
        Object.assign(generic, this.pageMap)
        return generic
      },
      createGenericParams (index = 0) {
        let generic = this.tables[index].url.originData.generic
        return mapGenericSearchParams(this.formFields, this.getFormModel(), generic)
      },
      getData (index = 0) {
        let obj = this.queryModule[index]
        return (obj && obj.res) || {}
      },
      getTableData (index = 0) {
        let obj = this.queryModule[index] || {}
        if (obj.data) {
          this.remotePage[index] = obj.data.page || 1
        }
        return (obj.res && obj.res.rows) || EMPTY_ARR
      },
      getTableSortData(index = 0) {
        if (this.tables.length === 1) {
          return this.$refs.tableList.$refs.table.tableData()
        }
        return this.$refs.tableList[index].$refs.table.tableData()
      },
      setTableColumns (option, index = 0) {
        let tab = this.tables[index]
        let columns = tab.columns
        let keys = []
        columns.forEach(v => {
          let obj = option[v.key]
          if (obj) {
            v.undraggable = !v.show
            Object.assign(v, obj)
            v.$show = v.show
            v.$fixed = v.fixed && v.fixed === 'left'
            // 2021-08-27 兼容二级头有 fixed 情况
            if (Array.isArray(v.children) && v.children.length) {
              v.children.forEach(child => {
                child.fixed = v.$fixed ? 'left' : ''
              })
            }
          } else {
            if (Array.isArray(v.children) && v.children.length) {
              v.children.forEach(child => {
                let obj = option[child.key]
                if (obj) {
                  child.undraggable = !child.show
                  Object.assign(child, obj)
                  child.$show = child.show
                  // 2021-08-27 兼容二级头有 fixed 情况
                  v.$fixed = child.fixed && child.fixed === 'left'
                  v.fixed = v.$fixed ? 'left' : ''
                }
              })
            }
          }

          if (v.fixed && v.fixed === 'left') {
            keys.push(v.key)
          }
        })

        // 浏览器缓存固定列
        if (columns && Array.isArray(columns) && columns.length > 0) {
          this.storeFixedColumns(tab, keys)
        }

        if (this.tables.length === 1) {
          this.$refs.tableList.$refs.table.setTableColumns(option)
        } else if (this.tables.length > 1) {
          this.$refs.tableList[index].$refs.table.setTableColumns(option)
        }
      },
      setGenericFields (option) {
        if (this.generic && this.generic.searchCode) {
          this.$refs.genericDialog.setGenericFields(option)
        }
      },
      showDragDialog (val = true) {
        if (window.__ERP_TABLE_CONFIG_FLAG) {
          this.$message.warning('表格当前为配置编辑模式, 无法进行个性设置')
          return
        }
        this.$refs.dragDialog.show = val
      },
      showGenericDialog (val = true) {
        this.$refs.genericDialog.show = val
      },
      openGenericDialog () {
        this.$emit('open-gerernic-dialog')
      },
      setGenericRules (rules) {
        // 用户设置的规则需要深拷贝，切断引用导致的通用查询相关问题
        this.$refs.genericDialog && this.$refs.genericDialog.$refs.rule.setRules(cloneDeep(rules))
      },
      page (index) {
        let obj = this.queryModule[index]
        return (obj && obj.data && obj.data.page) || this.pageMap.page
      },
      pageSize (index) {
        let obj = this.queryModule[index]
        return (obj && obj.data && obj.data.pageSize) || this.pageMap.pageSize
      },
      total (index) {
        let obj = this.queryModule[index]
        return (obj && obj.res && obj.res.rowTotal) || 0
      },
      sortChange(index, e) {
        this.$emit('sort-change', index, e)
        const sortChange = this.tables[index].option && this.tables[index].option.sortChange
        if (typeof sortChange === 'function') {
          sortChange(index, e)
        }
        if (e.remote) {
          let method = this.tables[index].method || this.tables[index].url.method
          let auth = this.tables[index].url.authCode || method
          if (!this.option.auth || this.permissionMenus.includes(auth)) {
            this.tables[index].option.sort = e
            this.loadData({}, index, method, this.tables[index].axios, HTTP_ACTION.SORT)
          } else {
            console.log(`[query-table]: ${method} 远程排序无权限`)
          }
        } else if (this.option.module) {
          // 本地数据排序后，详情页分页器的ids需要保持顺序一致
          setTimeout(_ => {
            let module = this.$store.state.queryTable[this.option.module]
            if (module) {
              if (this.tables.length === 1) {
                module.sortIndexs = this.$refs.tableList.$refs.table.flatData.map(v => v._index - 1)
              } else {
                module.sortIndexs = this.$refs.tableList[index].$refs.table.flatData.map(v => v._index - 1)
              }
            }
          }, 10)
        }
      },
      handleRemoteSort (data, defSort, sortConf) {
        let hasDefSort = defSort && defSort.keys && defSort.keys.length
        if (sortConf) {
          if (sortConf.order) {
            if (!sortConf.column.sortKeys) return
            let prop = sortConf.column.sortKeys[data.elasticsearchFlag === 'Y' ? 0 : 1]
            let order = sortConf.order === 'ascending' ? 0 : 1
            data.orderByClauses = [{ field: prop, orderByMode: order }]
          } else {
            delete data.orderByClauses
          }
        } else if (!sortConf && hasDefSort) {
          let prop = defSort.keys[data.elasticsearchFlag === 'Y' ? 0 : 1]
          let order = defSort.order === 'ascending' ? 0 : 1
          data.orderByClauses = [{ field: prop, orderByMode: order }]
        }
      },
      doHttp (method, url, headerUrl, data, option, index, action) {
        method = method || url.method

        // 测试环境全局只有权限编码，生产环境apiCode与权限编码同时存在，测试环境无authCode不校验
        const authCode = url.authCode
        // 只做提示不做拦截
        const auth = authCode || method
        if (authCode && this.option.auth && !this.permissionMenus.includes(auth)) {
          console.error(`[query-table]: 列表查询受权限控制，当前查询无[${authCode}]权限编码权限，请到[权限分配]模块分配权限或联系模块开发人员`)
        }

        // 本地排序
        let module = this.$store.state.queryTable[this.option.module]
        if (module) {
          module.sortIndexs = null
        }
        // 处理请求头
        let axios = this.tables[index].axios
        let fn = option.beforeHttpAxios
        if (fn && typeof fn === 'function') {
          axios = fn(action, method, data, axios)
        }
        this.tables[index].axios = axios
        // 非轮训增加loading
        if (!this.stopShowLoading && action !== HTTP_ACTION.TIMEOUT) {
          this.setLoading(true)
        }
        if (axios && axios.headers) {
          axios.headers = {
            ...axios.headers,
            'method-type': 'search'
          }
        } else {
          axios = {
            ...axios,
            headers: {
              'method-type': 'search'
            }
          }
        }

        // 查询后上报页面展示信息
        const menu = getMenuIdByRoute(this.$store, this.$route)
        genericSearchFieldsUpload({
          menuId: menu && menu.id,
          action,
          method,
          columns: this.tables[index].columns,
          columnsSearchCode: data._columnSearchCode,
          formFields: this.formFields,
          querySearchCode: data._querySearchCode,
          formModel: this.getFormModel(),
          genericFields: this.generic.configColumns,
          genericSearchCode: data.genericSearchCode,
          genericVos: data.generic && data.generic.vos
        })

        // 2021-11-11 数据与总数并行查询 table.option.lazyLoadPages
        // searchMode 0 默认查询分页  1 仅查询数据  2 仅查询count
        const lazyLoadPages = this.tables[index].option.lazyLoadPages
        // 2021-11-11 判断是否是code。如果是string，则表示需要用传入的method，否则沿用之前的method
        const lazyLoadPagesCode = typeof lazyLoadPages === 'string' ? lazyLoadPages : method

        let lazyLoadPromise = null

        if (lazyLoadPages) {
          lazyLoadPromise = this.$http(lazyLoadPagesCode, this.setRequestParams({ ...cloneDeep(data), searchMode: 2 }), axios ? { axios } : null)
        }

        const searchMode = lazyLoadPages ? 1 : 0
        return this.$http(method, this.setRequestParams({ ...cloneDeep(data), searchMode }), axios ? { axios } : null).then(res => {
          this.remotePage[index] = data.page || 1
          // 容错后台数据
          res = perfectRows(res)
          // 扁平化 区间列
          mapSectionValueList(res.rows, headerUrl && headerUrl.sectionOption)

          const option = this.tables[index].option
          if (res.rows && res.rows.length === 0 && !option.emptyText) {
            option.emptyText = '查询结果为空'
            if (res.noDataPermission) {
              option.emptyText = '无权查看数据'
            }
          }

          this.setLoading(false)

          this.$emit(TABLE_EVENTS.DATA_LOADED, res)

          if (lazyLoadPages) {
            if (this.option.module) {
              const originData = this.queryModule[index]
              this.setQuery({ index, res: { ...originData.res, rows: res.rows } })
            } else {
              url.res = { ...url.res, rows: res.rows }
            }
          } else {
            if (this.option.module) {
              this.setQuery({ index, res })
            } else {
              url.res = res
            }
          }

          this.$emit('change', res, index)
          if (!this.tables[index].option.disabledAutoDecrypt) {
            // 批量自动解密
            let bizId = this.tables[index].option.bizIdKey || 'id'
            // DecryptPlugin.setDecryptMethod(method)
            DecryptPlugin.batchDecrypt(this.option.menuId, bizId, res.rows, _ => {
              if (this.option.module) {
                res.rows = [...res.rows]
                this.setQuery({ index, res })
              }
              checkBatchDecryptConf(this.maxDecryptConfig[method], res.rows, bizId)
            })
          }
          if (lazyLoadPages) {
            lazyLoadPromise.then(res => {
              if (this.option.module) {
                const originData = this.queryModule[index]
                this.setQuery({ index, res: { ...res, rows: originData.res.rows } })
              } else {
                url.res = {
                  ...url.res,
                  pageTotal: res.pageTotal,
                  rowTotal: res.rowTotal,
                  page: res.page
                }
              }
            })
          }

          // 缓存：预加载下一页，最多查询2万条数据
          // ERPSearchPreload：用户快速点击分页按钮时，重复的http请求会被取消
          if (this.canFetchNextPage(res, data, option)) {
            let preData = cloneDeep(data)
            preData.searchMode = searchMode
            preData.page = data.page + 1
            preData.ERPSearchPreload = true
            delete preData.forceCache
            let conf = axios ? { axios, cancel: true } : false
            let fn = option.beforeHttp
            if (fn && typeof fn === 'function') {
              const beforeHttp = fn(preData, HTTP_ACTION.PAGER)
              if (beforeHttp && beforeHttp.then) {
                beforeHttp.then(() => this.$http(method, this.setRequestParams(preData), conf))
              } else {
                this.$http(method, this.setRequestParams(preData), conf)
              }
            } else {
              this.$http(method, this.setRequestParams(preData), conf)
            }
          }
          this.clearHScroll(index, action)
          this.isScrollY()
          return res
        }).catch(e => {
          this.setLoading(false)
          this.$emit('http-error', e)
          throw e
        })
      },
      setRequestParams (data) {
        // 自定义请求参数
        const index = +this.active
        const { option } = this.tables[index]
        let func = option.beforeHttpParams
        const isFunc = func && typeof func === 'function'
        return isFunc ? func(data) : data
      },
      // 2021-09-26 增加分页限制参数
      canFetchNextPage (res, data, option) {
        if (option.lazyLoadPages || option.disabledNextPage) {
          return false
        }
        const MAX_PAGE_COUNT = 100 * 200 // 总数
        // 1、有分页限制：后台总条数大于当前页总条数，且当前页码page小于100（20000 / 200）
        // 2、无分页限制：后台总条数大于当前页总条数
        return option.disabledMaxPage
          ? res.rowTotal > data.page * data.pageSize
          : res.rowTotal > data.page * data.pageSize && data.page < MAX_PAGE_COUNT / (data.pageSize || this.pageMap.pageSize)
      },
      // 2020-01-27 是否限制最大分页
      disabledMaxPage (index) {
        return this.tables[index].option.disabledMaxPage
      },
      handleDataBeforeHttp (data, option, index, action) {
        // 自定义查询、通用查询 可以分别设置是否支持ES
        // if (action === HTTP_ACTION.FORM && this.option.formEsFlag) {
        //   data.elasticsearchFlag = this.option.formEsFlag
        // } else if (action === HTTP_ACTION.GENERIC && this.option.genericEsFlag) {
        //   data.elasticsearchFlag = this.option.genericEsFlag
        // }
        // 添加接口缓存标志
        data.ERPSearchCacheFlag = true
        if (this.forceCache) {
          data.forceCache = true
        } else {
          delete data.forceCache
        }
        // 通用查询 menuId、genericSearchCode
        if (this.generic && this.generic.searchCode) {
          data.menuId = this.option.menuId
          data.genericSearchCode = this.generic.searchCode
        }
        // 自定义查询
        if (this.option && this.option.searchCode) {
          data._querySearchCode = this.option.searchCode
        }
        // 自定义列
        if (this.tables && this.tables.length) {
          data._columnSearchCode = this.tables[index].searchCode
        }
      },
      async getList (index, method, action) {
        const { url, option, headerUrl } = this.tables[index]
        const data = this.queryModule[index].data || {}
        this.handleDataBeforeHttp(data, option, index, action)
        this.handleRemoteSort(data, option.defaultSort, option.sort)
        let fn = option.beforeHttp
        if (fn && typeof fn === 'function') {
          let flag = false
          const beforeHttp = fn(data, action)
          if (beforeHttp && beforeHttp.then) {
            flag = await beforeHttp
          } else {
            flag = beforeHttp
          }
          if (flag === true) {
            this.setLoading(false)
            return Promise.resolve(false)
          }
        }
        if (data.generic && data.generic.vos) {
          perfectVos(data.generic.vos)
          // 日期范围拦截
          if (action !== HTTP_ACTION.SORT && action !== HTTP_ACTION.PAGER) {
            let promise = this.dateRangeIntercept(data.generic.vos)
            if (promise) {
              return promise.then(_ => {
                return this.getListPromise(method, url, headerUrl, data, option, index, action)
              }).catch(console.log)
            }
          }
        }
        return this.getListPromise(method, url, headerUrl, data, option, index, action)
      },
      getListPromise (method, url, headerUrl, data, option, index, action) {
        // TODO 后台消息队列延迟尚未解决，前端延迟执行
        if (data.elasticsearchFlag === 'Y' && this.forceCache && this.isRefresh) {
          this.isRefresh = false
          return new Promise(resolve => {
            setTimeout(() => {
              resolve(this.doHttp(method, url, headerUrl, data, option, index, action))
            }, 1000)
          })
        }
        return this.doHttp(method, url, headerUrl, data, option, index, action)
      },
      handleSizeChange (val) {
        this.pageMap.pageSize = val
        let index = +this.active
        const data = { page: this.pageMap.page, pageSize: val }
        if (this.option.module) {
          this.setQuery({ index, data })
        } else {
          Object.assign(this.tables[index].url.data, data)
        }
        this.forceCache = true
        this.getList(index, this.tables[index].method, HTTP_ACTION.PAGER)
      },
      handleCurrentChange (val) {
        let index = +this.active
        const data = { page: val }
        if (this.option.module) {
          this.setQuery({ index, data })
        } else {
          Object.assign(this.tables[index].url.data, data)
        }
        this.forceCache = false
        this.getList(index, this.tables[index].method, HTTP_ACTION.PAGER)
      },
      formSubmit (model, params, log) {
        this.queryLog_zh_cn = log
        let index = this.formIndex === -1 ? +this.active : this.formIndex
        this.initQueryParams(model, index, params)
        let fn = this.tables[index].option.beforeFormSubmit
        if (fn && typeof fn === 'function' && fn(this.queryModule[index].data, model) === true) {
          return
        }
        this.forceCache = true
        this.tables[index].method = ''
        this.getList(index, null, HTTP_ACTION.FORM)
        if (this.$refs.tools) {
          this.$refs.tools.clearActiveBtn()
        }
      },
      formReset (model) {
        let index = this.formIndex === -1 ? +this.active : this.formIndex
        let option = this.tables[index].option
        if (typeof option.beforeFormReset === 'function') {
          option.beforeFormReset(this.queryModule[index].data, model)
        }
      },
      registerStoreModule () {
        const module = this.option.module
        if (!module) {
          return
        }
        // 渲染慢的场景下，route实时获取meta可能不准确（例如v-if动态渲染）
        let tag = this.option.menuRouteTag
        let moduleTag = this.$store.state.queryTable.$module[module]
        if (moduleTag && tag !== moduleTag) {
          let msg = `QueryTable组件子模块“'${module}':'${moduleTag}'”已注册，不能重复注册！`
          this.$alert(msg, '提示', { type: 'error', showClose: false })
          return
        }
        if (!moduleTag) {
          this.$store.registerModule(['queryTable', module], createStoreModule())
          this.$store.commit('queryTable/registerModule', { module, tag })
        }
        this.tables.forEach((v, i) => this.setQuery({ index: i, data: v.url.data }))
      },
      setQuery (payload) {
        if (this.$store.state.queryTable[this.option.module]) {
          this.$store.commit(this.queryTableAction.setQuery(this.option.module), payload)
        }
      },
      initQueryParams (model, index, params) {
        let url = this.tables[index].url
        if (this.option.module) {
          let generic = this.tables[index].url.originData.generic
          if (params && params.generic) {
            Object.assign(params.generic, generic)
          } else if (!params && this.formFields.length) {
            params = {
              ...mapFormModelParams(this.formFields, model),
              ...mapGenericSearchParams(this.formFields, model, generic)
            }
          }
          let data = { ...url.data, page: this.pageMap.page, ...params }
          this.setQuery({ index, data })
        } else {
          let data = { ...url.data, page: this.pageMap.page }
          let isGeneric = this.formFields.some(v => {
            return (v.columnType && v.operation) || (v.options && v.options.some(k => k.columnType && k.operation))
          })
          if (isGeneric) { // 通用查询
            let generic = this.tables[index].url.originData.generic
            if (params && params.generic) {
              Object.assign(params.generic, generic)
            } else if (!params) {
              params = {
                ...mapFormModelParams(this.formFields, model),
                ...mapGenericSearchParams(this.formFields, model, generic)
              }
            }
          }
          Object.assign(data, params)
          url.data = data
        }
      },
      initOption () {
        // 检测是否在 dialog 中使用
        let isDialog = !this.option.dialog && this.$parent && (
          (this.$parent.modalAppendToBody) ||
          (this.$parent.$parent && this.$parent.$parent.modalAppendToBody)
        )
        if (isDialog) {
          this.option.dialog = true
          this.option.pageFooter = this.option.pageFooter !== false
        }
        // const menu = this.$store.getters.menus[this.$route.meta.tag]
        const menu = getMenuIdByRoute(this.$store, this.$route)
        const menuRouteTag = this.$route.meta.tag
        let obj = {
          inline: true,
          auth: true,
          unpager: true, // 是否需要详情页的上下分页器
          // draggable: !this.option.dialog,
          draggable: true,
          module: this.option.dialog ? false : !!(this.generic && this.generic.searchCode),
          menuId: menu && menu.id,
          menuRouteTag
        }
        Object.assign(obj, this.option)
        // 有通用查询需求时，如果没有设置 module，则自动设置 module
        if (obj.module && typeof obj.module === 'boolean') {
          obj.module = this.tables[0].url.method
        }
        Object.assign(this.option, obj)
        // 2022-11-04 增加权限编码判断
        this.option.auth = this.option.auth ? this.tables[0].url.authCode || this.tables[0].url.method : ''
      },
      initTables () {
        this.tables.forEach((v, i) => {
          this.remotePage[i] = 1
          v.option = Object.assign({
            type: 'index', // index, selection
            border: true,
            stripe: true,
            page: true,
            load: true
          }, v.option)
          this.initUrl(v.url, v.headerUrl)
          this.initEvent(v, i)
          this.$set(v, '$columns', [])
          if (!v.columns) {
            this.$set(v, 'columns', [])
          }
          if (v.operation && Object.keys(v.operation).length) {
            v.operation.label = v.operation.label || '操作'
            v.operation.width = v.operation.width || 40
            v.operation.fixed = v.operation.fixed || 'left'
          }
        })
      },
      initUrl (url, headerUrl) {
        this.$set(url, 'res', { rows: [], rowTotal: 0 })
        let data = {
          ...this.pageMap,
          elasticsearchFlag: 'Y',
          generic: { vos: [] },
          ...url.data
        }
        data.generic.vos = data.generic.vos || []
        if (url.data) {
          url.originData = JSON.parse(JSON.stringify(url.data))
        } else {
          url.originData = {}
        }
        this.$set(url, 'data', data)
        if (headerUrl && headerUrl.sectionOption) {
          headerUrl.sectionOption.$row = `$${headerUrl.sectionOption.row}`
        }
      },
      initEvent (v, i) {
        const func = v.option.rowDblClick
        if (this.option.module && func) {
          v.option.rowDblClick = (row, column, value) => {
            this.setPager(v.option.idKey, i)
            func(row, column, value)
          }
        }
        if (!v.option.cellClick) {
          v.option.cellClick = _ => {
          }
        }

        if (!v.option.anyCellClick) {
          v.option.anyCellClick = _ => {
          }
        }
      },
      // 双击进入详情前，初始化详情页【翻页功能】需要的数据
      setPager (idKey, index = 0) {
        idKey = idKey || this.tables[index].option.idKey
        this.$store.commit(this.queryTableAction.setPager(this.option.module), { idKey, index })
      },
      triggerHttp (model = {}, params) {
        let load = false
        this.tables.forEach((tab, i) => {
          this.initQueryParams(model, i, params)
          if (tab.option.load) {
            load = true
            this.setLoading(true)
            this.forceCache = true
            this.getList(i, null, HTTP_ACTION.FORM)
          }
          if (tab.option.timeout) {
            this.collectPoll(tab, i)
          }
        })
        !load && this.setLoading(false)
        return load
      },
      collectPoll (tab, index) {
        const timeout = tab.option.timeout
        this.collectTimerArr.push({
          callback: () => setInterval(_ => this.getList(index, null, HTTP_ACTION.TIMEOUT), timeout),
          timer: null
        })
        this.createPoll()
      },
      createPoll () {
        this.collectTimerArr.forEach(item => item.timer = item.callback())
      },
      destoryPoll () {
        this.collectTimerArr.forEach(item => {
          clearInterval(item.timer)
          item.timer = null
        })
      },
      initLocalFormTable () {
        if (this.formFields.length) {
          this.option.searchCode = ''
          this.setFormFieldsLabel(this.formFields)
        }
        let isLocalTable = this.tables.every(v => v.columns.length > 0)
        if (isLocalTable) {
          for (let i = 0, len = this.tables.length; i < len; i++) {
            let tab = this.tables[i]
            tab.searchCode = ''
            let prefix = `${tab.url.method}.data.rows.`
            tab.columns.forEach(v => this.mergeColumn(tab, v, prefix))
            // 获取区间列配置
            if (tab.headerUrl && tab.headerUrl.method) {
              this.getHeader(tab, tab.headerUrl.data, i)
            }
          }
          if (!this.option.searchCode && this.formFields.length === 0) {
            this.triggerHttp()
          }
          this.canLoad = true
          this.isScrollY()
          this.$emit('created')
        }
        return isLocalTable && !this.option.searchCode
      },
      async getGenericSearchFields () {
        this.labelFields = {}
        if (this.initLocalFormTable()) {
          return
        }
        try {
          this.setLoading(true)
          // 获取用户自定义配置
          let menuId = this.option.menuId
          let params = { menuId, time: random() }
          if (Array.isArray(this.searchCodes) && this.searchCodes.length) {
            params.searchCodes = this.searchCodes
          }
          // 同一时间重复的请求会被取消，所以带上时间戳
          let res = await this.$http('system.genericSearch.listByMenuId', params)
          if (res && res.length) {
            if (this.$refs.genericDialog) {
              this.setGenericSearchFields(res)
            }
            const tasks = [this.getFormFields(res), ...this.getColumns(res), this.getDeptFields(res)]
            await Promise.all(tasks)
            this.mergeDept()
            this.getDeptData(res)
          }
          this.configError = false
          if (!this.canLoad) {
            if (this.formFields.length === 0) {
              this.triggerHttp()
            }
            this.canLoad = true
            this.isScrollY()
            this.$emit('created')
          }
        } catch (e) {
          console.error(e)
          if (!this.option.menuId) {
            console.error('queryTable获取menuId错误，请使用public/utils的【getRenderMenuId】方法获取menuId，添加给query-table的option属性中')
          }
          this.configError = true
          this.setLoading(false)
        }
      },
      getHeader (tab, params, index = 0) {
        return this.$http(tab.headerUrl.method, params, tab.headerUrl.appkey).then(res => {
          if (tab.headerUrl.sectionOption) {
            if (!res || !res.length) {
              this.$emit('change-header', res, index)
              return
            }
            let $rowKey = tab.headerUrl.sectionOption.$row
            let columnKey = tab.headerUrl.sectionOption.columnKey
            let columnLabel = tab.headerUrl.sectionOption.columnLabel
            let arr = res.map(v => {
              return {
                section: v,
                key: `${$rowKey}.${v[columnKey]}`,
                label: v[columnLabel],
                width: '110px',
                auth: true,
                show: true,
                $show: true,
                undraggable: true
              }
            })
            // 可对接口获取的区间列配置进行 formatter 操作，自行添加修改属性(如排序、二级表头等)
            if (tab.headerUrl.cloumnsFormatter && typeof tab.headerUrl.cloumnsFormatter === 'function') {
              arr = tab.headerUrl.cloumnsFormatter(arr)
            }
            if (tab.columns.some(v => v.key.indexOf($rowKey) !== -1)) {
              tab.columns = tab.columns.filter(v => v.key.indexOf($rowKey) === -1)
            }
            // 区间列插入到指定位置 sectionIndex
            let sectionIndex = tab.columns.findIndex(v => !!v.sectionIndex)
            sectionIndex = sectionIndex === -1 ? tab.columns.length : sectionIndex
            tab.columns.splice(sectionIndex, 0, ...arr)
            tab.$columns = [...tab.columns]
            this.$emit('change-header', res, index)
          }
        })
      },
      getFormFields (userRes) {
        let obj = this.option.searchCode
        obj = obj && userRes.find(v => v.searchCode === obj)
        if (!obj) {
          return Promise.resolve(true)
        }
        this.option.formEsFlag = obj.esFlag === '10' ? 'Y' : 'N'
        this.option[obj.searchCode] = obj.id
        // 如果用户保存了自定义查询，需要获取自定义查询公共配置
        // 容错处理：没有返回正确的个性模板，则返回公共模板
        let userArr = JSON.parse(obj.fieldContent || '[]')
        if (!userArr || !userArr[0] || typeof userArr[0] === 'string') {
          return this.$http('system.genericSearch.get', { id: obj.id, time: random() })
            .then(res => {
              const originArr = JSON.parse(res.fieldContent)
              // 用户上次操作个性设置时，全量数据
              const snapshotObj = JSON.parse(res.fieldSnapshot || '{}')
              this.option['common_' + obj.searchCode] = res.fieldContent
              this.setFormFields(originArr, userArr, snapshotObj)
            })
        } else {
          this.setFormFields(userArr)
          return Promise.resolve(true)
        }
      },
      // 设置自定义查询
      setFormFieldsByUser (data) {
        if (Array.isArray(data) && data.length) {
          this.formFields.splice(0, this.formFields.length, ...data)
          this.copyFormFields.$columns = data
          this.setFormFieldsLabel(data)
        }
      },
      setFormFields (originArr, userArr, snapshotObj) {
        if (originArr && originArr.length) {
          // 过滤无权限
          originArr = filterFieldsByAuthCode(originArr, 'query')
          // Todo 对比合并个性设置数据（新增字段、字段排序、显示隐藏） 需要单独抽模块处理
          mergeFormFields(originArr, userArr, snapshotObj, this.option)
          this.formFields.push(...originArr)
          this.copyFormFields.$columns.push(...originArr)
          this.setFormFieldsLabel(originArr)
          this.$nextTick(_ => {
            this.handleResize()
            this.$emit('query-form-created')
          })
        }
      },
      updateFormFieldStatus (originField, v, snapshotObj) {
        // 更新 formField 的 show 状态
        updateFormFieldShowStatus(originField, v, snapshotObj)
      },
      getColumns (userRes) {
        const tasks = []
        for (let i = 0, len = this.tables.length; i < len; i++) {
          let tab = this.tables[i]
          let obj = tab.searchCode
          obj = obj && userRes.find(v => v.searchCode === obj)
          if (obj) {
            this.option[obj.searchCode] = obj.id
            let esFlag = this.option.formEsFlag || (obj.esFlag === '10' ? 'Y' : 'N')
            tab.url.data.elasticsearchFlag = esFlag
            if (this.option.module) {
              this.setQuery({ index: i, data: { elasticsearchFlag: esFlag } })
            }
            // 如果用户保存了自定义列，需要获取自定义列公共配置
            // 容错处理：没有返回正确的个性模板，则返回公共模板
            // 2021-11-02 增加列权限字段，如果有列权限，则需要请求接口，拿到后端过滤原始数据的数据
            let userArr = JSON.parse(obj.fieldContent || '[]')
            // if (!userArr || !userArr[0] || typeof userArr[0] === 'string') {
            // 2022-06-30 列权限时，通用查询无法取上个环境列权限数据
            const isUserData = !userArr || !userArr[0] || typeof userArr[0] === 'string' || userArr[0].child
            if ((!(document.cookie && document.cookie.includes('gray-sys=1')) && tab.option.authColunms) || isUserData) {
              let params = {
                id: obj.id,
                time: random()
              }
              if (tab.option.authColunms) {
                params.apiCode = tab.url.method
              }
              let task = this.$http('system.genericSearch.get', params)
                .then(res => {
                  let originArr = JSON.parse(res.fieldContent)
                  // 2021-11-19 新增字段，表示是否有上个版本的全字段配置
                  let snapshotObj = JSON.parse(res.fieldSnapshot || '{}')
                  // 2022-06-30 列权限时，二级头为空，则不显示一级头
                  if (tab.option.authColunms) {
                    originArr = originArr.filter(v => !(v.children && Array.isArray(v.children) && v.children.length === 0))
                    // 列权限，导致userArr可能是原始数据
                    if (!isUserData) {
                      userArr = null
                    }
                  }
                  // 列权限，导致个性设置重置按钮显示
                  if (isUserData) {
                    this.option['common_' + obj.searchCode] = JSON.stringify(originArr)
                  }
                  this.setColumns(tab, originArr, userArr, snapshotObj)
                })
              tasks.push(task)
            } else {
              this.setColumns(tab, userArr)
            }
            // 获取区间列配置
            if (tab.headerUrl && tab.headerUrl.method) {
              tasks.push(this.getHeader(tab, tab.headerUrl.data, i))
            }
          }
        }
        return tasks
      },
      // 设置自定义列
      setColumnsByUser (data, index = +this.active, isMerge = true) {
        if (Array.isArray(data) && data.length) {
          const tab = this.tables[index]
          isMerge && data.forEach(item => this.mergeColumn(tab, item))
          tab.columns = data
          tab.$columns = [...data]
        }
      },
      setColumns (tab, originArr, userArr, snapshotObj) {
        if (originArr && originArr.length) {
          // 过滤无权限
          originArr = filterFieldsByAuthCode(originArr, 'column')
          // 是否用用户自定义数据
          let flag = !!userArr
          // 用户自定义数据
          let userKeys = []
          let userChildKeys = {}
          // 如果没有交集，则取公共模板
          if (flag) {
            userKeys = userArr.map(item => {
              if (typeof item === 'string') return item
              if (item.child && item.child.length) userChildKeys[item.key] = item.child
              return item.key || ''
            })
            let keys = originArr.map(v => v.key)
            keys = intersection(keys, userKeys)
            flag = keys && keys.length > 0
          }
          let length = flag ? userArr.length : 0
          let prefix = `${tab.url.method}.data.rows.`
          originArr.forEach(v => {
            // 深拷贝，为了拿到原数据中一级头和二级头是否显示show的状态
            const originCol = cloneDeep(v)
            // 用户自定义的字段排序在前面
            if (flag) {
              let index = userKeys.indexOf(v.key) + 1
              v.index = index || ++length
              // v.show = index > 0 || !!v.fixed
              // 2021-08-18 动态固定列，显示隐藏优先级高
              v.show = index > 0
            }
            // 用户未保存数据不做处理
            if (v.show && v.children && userChildKeys[v.key]) {
              let childLength = flag ? userChildKeys[v.key].length : 0
                v.children.forEach(child => {
                  let childIndex = userChildKeys[v.key].indexOf(child.key) + 1
                  child.index = childIndex || ++childLength
                  child.show = childIndex > 0
              })
              v.children.sort((a, b) => a.index - b.index)
            }
            // 是否有用户快照数据
            const hasSnapshot = flag && snapshotObj && Object.keys(snapshotObj).length
            if (hasSnapshot) {
              // 是否有上个版本数据
              this.updateColumnStatus(originCol, v, snapshotObj, originArr)
            }
            // 设置扩展配置
            this.updateColumnConfig(tab, originCol, v, snapshotObj)
            this.mergeColumn(tab, v, prefix)
          })

          if (flag) {
            originArr.sort((a, b) => a.index - b.index)
          }
          tab.columns = originArr
          tab.$columns = [...originArr]
          this.$nextTick(_ => {
            this.$emit('table-columns-created')
          })
        }
      },
      updateColumnConfig (tab, originCol, col, snapshotObj) {
        // 未配置收起展开功能，无需预处理数据
        if (!(tab.option && tab.option.controlCollapseCol)) return
        // 收起展开-设置默认值
        const hasCollapseKeys = col.collapseKeys && col.collapseKeys.length > 0
        const snapshotItem = snapshotObj && snapshotObj[col.key]
        if (hasCollapseKeys) {
          // 仅判断自身是否支持收起展开，不影响子级遍历
          const isExpand = snapshotItem && snapshotItem.collapsed !== undefined ? !snapshotItem.collapsed : undefined
          col.$isExpand = isExpand !== undefined ? !!isExpand : !!(!col.collapsed && hasCollapseKeys)
          col.collapsed = !col.$isExpand
        }
        if (col.children && col.children.length) {
          // 遍历二级表头，设置默认值
          col.children.forEach(child => {
            const originChildCol = originCol.children.find(v => v.key === child.key)
            this.updateColumnConfig(tab, originChildCol, child, snapshotItem && snapshotItem.children)
          })
        }
      },
      // 2021-11-19 检查是当前一级头或二级头是否是新同步字段
      updateColumnStatus (originCol, v, snapshotObj, originArr) {
        const index = originArr.findIndex(item => item.key === v.key)
        const isNewKey = !snapshotObj[v.key] && originCol.show
        // 1、上个版本没有一级头字段，则表示该字段是新增字段
        v.show = v.show || isNewKey
        // 2、上个版本一级头字段，且没有二级头标识children，则表示二级头children都是新增字段
        if (v.children && snapshotObj[v.key] && !snapshotObj[v.key].children) {
          v.children.forEach((child, index) => {
            const findObj = originCol.children.find(item => item.key === child.key)
            child.show = findObj.show
          })
        }
        // 3、如果新旧版本字段都有二级头，查找二级头children中是否有新增字段
        if (v.show && v.children && snapshotObj[v.key] && snapshotObj[v.key].children) {
          v.children.forEach((child, index) => {
            const newFlag = !snapshotObj[v.key].children[child.key]
            const findIndex = originCol.children.findIndex(item => item.key === child.key)
            child.show = child.show || (newFlag && originCol.children[findIndex].show)
            child.index = newFlag ? findIndex : child.index
          })
          v.children.sort((a, b) => a.index - b.index)
        }
        // 2022-12-04 4、新增字段按照原有顺序排序
        if (isNewKey) {
          // 字段排序是通过添加索引排序，起始为1
          // sort方法相同大小排序，会导致先排序的字段会排在前面
          v.index = index
        }
      },
      mergeColumn (tab, v, prefix) {
        this.$set(v, '$show', !!v.show)
        this.$set(v, 'show', !!v.show)
        // 列自定义Formatter
        const formatter = tab.formatter
        if (formatter && formatter[v.key]) {
          v.formatter = formatter[v.key]
        }
        // 二级表头Formatter
        if (v.children && Array.isArray(v.children)) {
          v.children.forEach(child => {
            if (formatter && formatter[child.key]) {
              child.formatter = formatter[child.key]
            }
            // 二级头需根据一级头显示/隐藏
            if (tab.option.draggableChild) {
              const show = v.show ? !!child.show : false
              this.$set(child, 'show', show)
              this.$set(child, '$show', show)
            }
            // 2021-09-13 兼容处理：无个性设置二级头显示字段时，默认表格二级头显示
            if (!tab.option.draggableChild) {
              this.$set(child, 'show', true)
            }
          })
        }

        // 浏览器缓存固定列
        this.mergeFixedColumn(tab, v)

        // 列权限控制
        // !this.$store.getters.permission.columns.includes(`${prefix}${v.key}`)
        v.auth = true
      },
      mergeFixedColumn (tab, v) {
        if (!tab.searchCode) {
          return
        }
        let obj = localStorage.getItem('GLOBAL_FIXED_COL') || '{}'
        obj = JSON.parse(obj)
        let userFixedArr = obj[`${this.$route.meta.tag}?${tab.searchCode}`]
        let hasFixed = !!(v.fixed && v.fixed === 'left')
        // 一级头没有的情况。如果二级头有，则一级头增加固定，二级头需置空
        if (!hasFixed && v.children && Array.isArray(v.children)) {
          hasFixed = v.children.some(child => child.fixed && child.fixed === 'left')
          // 兼容处理，如果二级头有固定，先重置
          if (hasFixed) {
            v.children.forEach(child => {
              child.fixed = ''
            })
          }
        }
        // 如果有用户配置，优先级高
        if (userFixedArr && Array.isArray(userFixedArr)) {
          hasFixed = userFixedArr.indexOf(v.key) > -1
        }
        this.$set(v, 'fixed', hasFixed ? 'left' : '')
        this.$set(v, '$fixed', hasFixed)
      },
      // 2021-09-19 存储固定列
      storeFixedColumns (tab, keys = []) {
        if (!tab.searchCode) {
          return
        }
        let c = localStorage.getItem('GLOBAL_FIXED_COL') || '{}'
        c = JSON.parse(c)
        c = { ...c, [`${this.$route.meta.tag}?${tab.searchCode}`]: keys }
        localStorage.setItem('GLOBAL_FIXED_COL', JSON.stringify(c))
      },
      // 2021-010-26 通用查询个性设置
      setGenericSearchFields (res) {
        let code = this.generic.searchCode
        // 当前通用查询数据
        let opt = code && res.find(v => v.searchCode === code)
        if (opt) {
          // 通用查询公共模板配置
          let userArr = JSON.parse(opt.fieldContent || '[]')
          let has = typeof userArr[0] === 'string'
          let originArr = opt.columnList.map(v => {
            const show = v.show === undefined ? true : !!v.show
            return {
              ...v,
              show,
              $show: show
            }
          })
          if (has && this.generic.showGenericConfig) {
            // 2022-02-12 快照字段
            const snapshotObj = JSON.parse(opt.fieldSnapshot || '{}')
            // 如果没有交集，则取公共模板
            let keys = originArr.map(v => v.propertyName)
            keys = intersection(keys, userArr)
            if (keys && keys.length > 0) {
               // 用户保存的字段排前面
              let len = userArr.length + 1
              originArr.forEach(v => {
                const oiginStatus = v.show
                let index = userArr.indexOf(v.propertyName) + 1
                v.index = index || ++len
                v.show = index > 0
                // 检查是否有上个版本数据
                if (snapshotObj && Object.keys(snapshotObj).length) {
                  v.show = v.show || (!snapshotObj[v.propertyName] && oiginStatus)
                }
                v.$show = !!v.show
              })
              originArr.sort((a, b) => a.index - b.index)
            }
          }
          // 是否缓存本地  10开启  20关闭
          const disabledCacheSwitch = opt.cacheSwitch === '20' || this.generic.disabledLocalCache === true
          this.$set(this.generic, 'disabledLocalCache', disabledCacheSwitch)
          // 设置通用查询合并后的字段信息集合
          this.$set(this.generic, 'configColumns', originArr)
          // 如果有用户配置，则保存原数据，与个性设置重置功能对应
          has && (this.option['common_' + code] = opt.columnList)
          // 通过通用查询编码保存通用查询id
          this.option[code] = opt.id
          // 初始化通用查询
          this.$refs.genericDialog.setGenericSearchFields({ ...opt, columnList: originArr })
          // 如果有用户配置，则与通用查询公共配置合并
          has && this.$refs.genericDialog.mergeGenericFields()
          // 提取通用查询label，用于日期拦截提示语
          this.setGenericFieldsLabel(originArr)
          this.option.genericEsFlag = opt.esFlag === '10' ? 'Y' : 'N'
        }
      },
      mergeDept (conf) {
        if (this.depts && this.depts.length) {
          let isChange = !!conf
          conf = conf || this.depts.reduce((s, v) => {
            s[`${v.type || 'list_'}${v.key}`] = v.dept
            return s
          }, {})
          this.tables.forEach(tab => {
            let type = tab.option.deptType || 'list_'
            tab.columns.forEach(v => {
              let val = conf[`${type}${v.key}`]
              if (val) {
                v.dept = val
                v.filter = 'deptFilter'
              }
            })
          })
          if (isChange) {
            this.loadCurrentData(+this.active)
          }
        }
      },
      getDeptFields (userRes) {
        let obj = this.option.deptSearchCode
        obj = obj && userRes.find(v => v.searchCode === obj)
        if (!obj) {
          return Promise.resolve(true)
        }
        this.option[obj.searchCode] = obj.id
        // 如果用户保存了点部，需要获取点部公共配置
        // 容错处理：没有返回正确的个性模板，则返回公共模板
        let userArr = JSON.parse(obj.fieldContent || '[]')
        if (Array.isArray(userArr) && userArr.length) {
          this.setDeptFields(userArr)
          return Promise.resolve(true)
        } else {
          return this.$http('system.genericSearch.get', { id: obj.id, time: random() })
            .then(res => this.setDeptFields(JSON.parse(res.fieldContent), userArr))
        }
      },
      setDeptFields (originArr, userObj = {}) {
        if (originArr && originArr.length) {
          originArr.forEach(v => {
            v.dept = userObj[v.key] || v.dept || ''
            if (Array.isArray(v.dept)) {
              v.dept.sort()
            }
          })
          this.depts = originArr
        }
      },
      getTabLabel (option, index) {
        if (!option.tabLabelCount) {
          return option.label
        }
        return `${option.label}(${this.total(index)})`
      },
      tabClick () {
        this.$refs.tableList[+this.active].setCanvasWidth()
        let func = this.tables[+this.active].option.tabClick
        func && func()
      },
      setCanvas () {
        if (this.tables.length > 1) {
          this.$refs.tableList[+this.active].setCanvasWidth()
        } else {
          this.$refs.tableList.setCanvasWidth()
        }
        this.$refs.queryForm && this.$refs.queryForm.handleRowFields()
      },
      repaint (val) {
        if (this.tables.length > 1) {
          this.$refs.tableList[+this.active].repaint(val)
        } else {
          this.$refs.tableList.repaint(val)
        }
      },
      tabDisabled (url) {
        const auth = url.authCode || url.method
        return !this.permissionMenus.includes(auth)
      },
      getDefaultValue (v, key) {
        if (this.formModel && this.formModel.hasOwnProperty(key)) {
          let func = this.formModel[key]
          return typeof func === 'function' ? func() : func
        } else {
          return v.default || ''
        }
      },
      canRefresh () {
        const tag = this.$route.meta.tag
        return !this.option.dialog && (this.option.canRefresh || this.$route.path === tag)
      },
      onRefreshMainQueryTable () {
        let tag = this.$route.meta.tag
        let isRefresh = this.canRefresh() && !this._inactive
        if (isRefresh) {
          let local = this.localRefreshMap[tag]
          let remote = this.refreshMap[tag]
          if (local || remote) {
            if (remote === true) {
              // 主页面多个 QueryTable 并且其父组件为 el-tab-pane，仅刷新激活的 el-tab-pane 对应的 QueryTable
              let el = this.$parent.$el
              let isTab = el.className.includes('el-tab-pane')
              if (!isTab || (isTab && el.style.display !== 'none')) {
                this.doRefresh(tag, local, remote)
              }
            } else if (remote && remote === this.option.module) {
              // 刷新指定的 module 对应的 QueryTable
              this.doRefresh(tag, local, remote)
            }
          }
        }
      },
      doRefresh (tag, local, remote) {
        this.$store.commit('queryTable/unrefresh', tag)
        if (local) {
          this.loadLocalData(local)
        } else if (remote) {
          this.isRefresh = true
          this.tables.forEach((v, i) => this.loadCurrentData(i, v.method))
        }
      },
      genericSubmit (data, log) {
        this.queryLog_zh_cn = log
        this.loadData(data, null, null, null, HTTP_ACTION.GENERIC)
      },
      onGenericLoaded (val) {
        this.genericModel = val
      },
      onTemplateListChange (val) {
        this.templateList = val
      },
      onGenericReset (e) {
        this.$emit('generic-reset', e)
      },
      columnWidthChange(...arg) {
        this.$emit('column-width-change', ...arg)
      },
      setLoading (val) {
        if (this.$props.isLoading || this.option.dialog) {
          this.loading = val
        } else {
          this.$store.commit('SET_LOADING', val)
        }
      },
      switchMenu (width) {
        this.offsetLeft = width + 16 + (this.option.offsetLeft || 0)
      },
      handleResize () {
        if (!this._inactive) {
          this.hasResize = false
          let len = this.tables.length
          if (len > 1) {
            for (let i = 0; i < len; i++) {
              this.$refs.tableList[i] && this.$refs.tableList[i].setCanvasHeight()
            }
          } else {
            this.$refs.tableList && this.$refs.tableList.setCanvasHeight()
          }
          this.isScrollY()
        } else {
          this.hasResize = true
        }
      },
      isScrollY () {
        if (this.option.dialog) {
          clearTimeout(this.scrollYTimmer)
          this.scrollYTimmer = setTimeout(_ => {
            let el = this.$el.querySelector('.kye-dialog-body') || this.$parent.$el.querySelector('.el-dialog__body')
            if (el && Math.abs(el.offsetHeight - el.scrollHeight) > 1) {
              this.scrollY = true
            }
          }, 200)
        }
      },
      // 清除 canvas 的定位
      clearHScroll (index, action) {
        if (action && action !== HTTP_ACTION.PAGER && this.$refs.tableList) {
          if (this.tables.length === 1) {
            this.$refs.tableList.$refs.table.clearHScroll()
          } else if (this.tables.length > 1) {
            this.$refs.tableList[index].$refs.table.clearHScroll()
          }
        }
      },
      setFormFieldsLabel (arr) {
        let obj = arr.reduce((s, v) => {
          if (v.propertyName) {
            s[v.propertyName] = v.label
          }
          if (v.columnName) {
            s[v.columnName] = v.label
          }
          if (v.options && v.options[0] && v.options[0].hasOwnProperty('propertyName')) {
            v.options.forEach(opt => {
              if (opt.propertyName) {
                s[opt.propertyName] = opt.label
              }
              if (opt.columnName) {
                s[opt.columnName] = opt.label
              }
            })
          }
          return s
        }, {})
        Object.assign(this.labelFields, obj)
      },
      setGenericFieldsLabel (arr) {
        if (!arr || !arr.length) {
          return
        }
        let obj = arr.reduce((s, v) => {
          s[v.key] = v.columnDisplayName
          return s
        }, {})
        Object.assign(this.labelFields, obj)
      },
      dateRangeIntercept (vos) {
        if (!vos.length || !window.__ERPGLOABLECONFIG__.dateRangeIntercept || this.option.dateRangeIntercept === false) {
          return false
        }
        let arr = []
        let reg = /^\d{4}-/
        vos.forEach(v => {
          if (v.type === 'date' && v.operation === 'between' && v.values[0] && v.values[1] && reg.test(v.values[0])) {
            let start = v.values[0]
            let end = v.values[1]
            let day = moment(end).diff(moment(start), 'day')
            let text = ''
            const label = this.labelFields[v.propertyName] || this.labelFields[v.columnName]
            if (day >= 360) {
              text = window.__ERPGLOABLECONFIG__.dateRange360
            } else if (day >= 180) {
              text = window.__ERPGLOABLECONFIG__.dateRange180
            } else if (day >= 90) {
              text = window.__ERPGLOABLECONFIG__.dateRange90
            }
            // 2022-12-12 vos中存在未配置自定义查询或者通用查询情况
            if (text && label) {
              arr.push(text.replace('$1', label))
            }
          }
        })
        if (arr.length) {
          return this.$confirm(`${arr.join('，')}${window.__ERPGLOABLECONFIG__.dateRangeAppend}`, '提示')
        }
        return false
      },
      toggleRowSelection (cb, index = 0) {
        if (this.tables.length === 1) {
          this.$refs.tableList.$refs.table.toggleRowSelection(cb)
        } else {
          this.$refs.tableList[index].$refs.table.toggleRowSelection(cb)
        }
      },
      /**
       *
       * @param log   中文查询条件
       * @param total 导出的数量
       * @param type  导出按钮对应的文案（用于区分有多个按钮的情况）
       */
      exportQueryLog ({ log, total, type } = {}) {
        exportQueryLog(log || this.queryLog_zh_cn, total || this.total(+this.active), type)
      },
      handleSwitchUnit (e) {
        this.$emit('switch-unit', e)
      },
      // 手动调用单位切换
      switchUnit () {
        this.$refs.searchPager.handleSwitchUnit()
      },
      headerMove (e) {
        this.$emit('header-move', e)
      },
      cellMove (e) {
        this.$emit('cell-move', e)
      },
      anyCellMove (e) {
        this.$emit('any-cell-move', e)
      },
      tableLeave (e) {
        this.$emit('table-leave', e)
      },
      tableScroll(e) {
        this.$emit('table-scroll', e)
      },
      columnsChange (type) {
        // 通用查询显示字段
        if (this.$refs.genericDialog && !this.generic.group) {
          this.$refs.genericDialog.mergeGenericFields()
        }
        this.$emit('columns-change', type)

        const menu = getMenuIdByRoute(this.$store, this.$route)
        const codes = this.getGenericSearchCodes()
        updateReportTimeByCodes(menu && menu.id, codes)
      },
      getGenericSearchCodes () {
        let codes = []
        // 通用查询
        if (this.generic && this.generic.searchCode) {
          codes.push(this.generic.searchCode)
        }
        // 自定义查询
        if (this.option && this.option.searchCode) {
          codes.push(this.option.searchCode)
        }
        // 自定义列
        this.tables.forEach(item => item.searchCode && codes.push(item.searchCode))
        return codes
      },
      setHeaderTipContent (contentArr = [], index = 1) {
        if (this.tables.length === 1) {
          return this.$refs.tableList.$refs.table.setHeaderTipContent(contentArr)
        }
        return this.$refs.tableList[index].$refs.table.setHeaderTipContent(contentArr)
      },
      // 2021-10-25 通过通用查询配置信息，判断是否需要预加载组织树
      async getDeptData (res) {
        let flag = false

        // 自定义查询检测是否有组织树
        for (let i = 0, len = this.formFields.length; i < len; i++) {
          let v = this.formFields[i]
          if (v.options && v.options.length) {
            flag = v.options.some(item => item.type === 'dept')
          } else {
            flag = v.type === 'dept'
          }
          if (flag) {
            break
          }
        }

        // 通用查询检测是否有组织树
        if (!flag && this.$refs.genericDialog) {
          let code = this.generic.searchCode
          let opt = code && res.find(v => v.searchCode === code)
          if (opt && opt.columnList && opt.columnList.length) {
            flag = opt.columnList.some(v => v.columnType === 'component' && v.lookupCode === 'dept')
          }
        }

        if (flag) {
          this.$bus.$emit('preload-dept-tree')
        }
      },
      // 2021-08-02 动态改变表单显示隐藏、禁用等
      setFormItem (option = {}) {
        this.formFields.forEach((v, idx) => {
          let key = v.propertyName
          let obj = option[key]
          if (obj) {
            // 自定义查询
            v.undraggable = !v.show
            let show = obj.show !== undefined ? obj.show : v.show
            this.$set(this.formFields, idx, {
              ...v,
              ...obj,
              show,
              $show: show
            })
          }
        })
        // 个性设置 - 自定义查询
        this.copyFormFields.$columns = cloneDeep(this.formFields)
      },
      // 获取最大解密条数的配置
      setCurrentMenuIdDecryptConfig() {
        queryCurrentMenuIdDecryptConfig().then(res => {
          this.maxDecryptConfig = res || {}
        })
      },
      // 动态切换自定义列 code
      async toggleColumns (searchCode) {
        const index = +this.active
        const tab = this.tables[index]
        const isClearSort = tab.searchCode !== searchCode
        tab.searchCode = searchCode
        // 切换自定义列，重置排序
        if (isClearSort) {
          this.clearSort()
        }
        try {
          // 获取用户自定义配置
          let menuId = this.option.menuId
          // 同一时间重复的请求会被取消，所以带上时间戳
          let res = await this.$http('system.genericSearch.listByMenuId', { menuId, time: random() })
          if (res && res.length) {
            this.getColumns(res)
          }
        } catch (e) {
          console.log('e', e)
        }
      },
      // 动态切换自定义查询 code
      async toggleFormFields (searchCode) {
        this.option.searchCode = searchCode
        try {
          // 获取用户自定义配置
          let menuId = this.option.menuId
          // 同一时间重复的请求会被取消，所以带上时间戳
          let res = await this.$http('system.genericSearch.listByMenuId', { menuId, time: random() })
          if (res && res.length) {
            this.formFields.splice(0, this.formFields.length)
            this.copyFormFields.$columns = []
            this.$nextTick(() => {
              this.getFormFields(res)
            })
          }
        } catch (e) {
          console.log('e', e)
        }
      },
      // 清空排序（参数及箭头交互）
      clearSort () {
        const index = +this.active
        const tab = this.tables[index]
        const table = this.tables.length === 1 ? this.$refs.tableList : this.$refs.tableList[index]
        const queryModuleInfo = this.queryModule[index]
        const { sort } = tab.option
        if (sort && sort.remote === true) {
          tab.option.sort = ''
        }
        delete queryModuleInfo.data.orderByClauses
        // 重置排序箭头交互
        table && table.clearSort()
      },
      emitSelectEvent (...args) {
        this.$emit('select', ...args)
      },
      emitSelectAllEvent(...args) {
        this.$emit('select-all', ...args)
      },
      emitHeaderEnter (...args) {
        this.$emit('header-enter', ...args)
      },
      emitCellMouseEnter (...args) {
        this.$emit('cell-mouse-enter', ...args)
      },
      emitCellMouseLeave (...args) {
        this.$emit('cell-mouse-leave', ...args)
      },
      emitCollapsed(index, ...args) {
        const tab = this.tables[index]
        const findCol = (cols, key) => {
          for (const col of cols) {
            if (col.key === key) return col
            if (!col.children) continue
            for (const child of col.children) {
              if (child.key === key) return child
            }
          }
          return null
        }
        // 是否启用折叠保存
        if (tab.option.enableCollapseSave) {
          const { collapsed, key } = args[0]
          let columns = tab.columns
          const col = findCol(columns, key)
          const collapseBgClass = 'table2-cell-collapse-bg'
          if (col) {
            col.collapsed = collapsed
            col.collapseKeys.forEach(collapseKey => {
              const collapseCol = findCol(columns, collapseKey)
              // 默认给展开列增加背景 （table2内部根据collapsed字段判断是否首次设置展开，如果首次展开则不会增加背景色）
              if (!collapseCol.className || !collapseCol.className.includes(collapseBgClass)) {
                collapseCol.className = `${collapseCol.className || ''} ${collapseBgClass}`
              }
            })
          }
        }
        this.$emit('collapsed', ...args)
      },
      // 设置内部属性
      setSearchCodeDataMap(codeName, data) {
        this._searchCodeDataMap = {
          ...this._searchCodeDataMap,
          [codeName]: data
        }
      },
      getTableConfigByIndex() {
        const index = +this.active
        return this.tables[index]
      },
      emitCallSuccess(...args) {
        this.$emit('call-success', ...args)
      },
      emitDecryptSuccess(...args) {
        this.$emit('decrypt-success', ...args)
      }
    }
  }
</script>

<style lang="scss">
  .query-table-container {
    .el-tabs__content {
      overflow: inherit
    }
    .jumper-button {
      margin-left: 10px;
      margin-right: 18px;
      padding-left: 6px;
      padding-right: 6px;
      min-width: unset !important;
      span {
        height: 14px;
        line-height: 14px;
      }
    }
    .fixedPagination {
      position: fixed;
      left: 176px;
      bottom: 8px;
      z-index: 10;
      background-color: #ffffff;
      padding-top: 8px;
    }
    .query-form-wrap {
      min-height: 32px;
      height: 32px;
      &_overflow {
        height: auto;
      }
      &_none {
        min-height: 0;
        height: 0;
      }
    }
    .error {
      cursor: pointer;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/index.vue